<template>
  <div class="register-wrapper d-flex justify-content-center align-items-center min-vh-100">
    <div class="card shadow-lg rounded-4 bg-white bg-opacity-75" style="width: 100%; max-width: 500px;">
      <div class="card-body p-4">
        <h2 class="text-center mb-4">Sign In Form</h2>

        <form @submit.prevent="handleLogin">
          <div class="mb-3">
            <label for="email" class="form-label">Email address</label>
            <input
              v-model="form.email"
              type="email"
              class="form-control"
              :class="{ 'is-invalid': errors.email }"
              id="email"
            >
            <div class="invalid-feedback">{{ errors.email }}</div>
          </div>

          <div class="mb-4">
            <label for="password" class="form-label">Password</label>
            <div class="input-group">
              <input
                :type="showPassword ? 'text' : 'password'"
                v-model="form.password"
                class="form-control"
                :class="{ 'is-invalid': errors.password }"
                id="password"
              >
              <button
                class="btn btn-outline-secondary"
                type="button"
                @click="togglePassword"
              >
                <i :class="showPassword ? 'fas fa-eye-slash' : 'fas fa-eye'"></i>
              </button>
              <div class="invalid-feedback d-block">{{ errors.password }}</div>
            </div>
          </div>

          <button type="submit" class="btn btn-primary w-100" :disabled="loading">
            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
            Login
          </button>

          <!-- Register & Reset Password dalam satu baris -->
          <div class="d-flex justify-content-between mt-4">
            <router-link to="/register" class="text-blue-500 hover:underline">
              Register
            </router-link>
            <router-link to="/forgotpassword" class="text-danger text-decoration-none">
              Reset Password
            </router-link>
          </div>

          <div v-if="errorMessage" class="alert alert-danger text-center mt-3">{{ errorMessage }}</div>
        </form>
      </div>
    </div>
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import alert from '@/utils/alert'

const showPassword = ref(false)
const togglePassword = () => {
  showPassword.value = !showPassword.value
}

const form = reactive({
  email: '',
  password: ''
})

const errors = reactive({})
const router = useRouter()
const loading = ref(false)
const errorMessage = ref('')

const validateForm = () => {
  errors.email = !form.email
    ? 'Email is required'
    : !/\S+@\S+\.\S+/.test(form.email)
    ? 'Email is invalid'
    : ''

  errors.password = !form.password ? 'Password is required' : ''

  return !errors.email && !errors.password
}

const handleLogin = async () => {
  loading.value = true
  errorMessage.value = ''
  
  if (!validateForm()) {
    loading.value = false
    return
  }

  try {
    const response = await axios.post('https://metatekapps.metateknologi.com/api-vms-auth.php', {
      email: form.email,
      password: form.password,
    })

    if (response.data.status === 200) {
      const user = response.data.data
      localStorage.setItem('token', user.token)
      localStorage.setItem('username', user.username)
      localStorage.setItem('nama', user.nama)
      localStorage.setItem('akses', user.akses)
      alert.success('Selamat Datang, ' + user.nama)
      router.push('/dashboard')
    } else {
      errorMessage.value = response.data.message || 'Login gagal.'
    }
  } catch (err) {
    errorMessage.value = err.response?.data?.message || 'Terjadi kesalahan saat login.'
  } finally {
    loading.value = false
  }
}
</script>

<style scoped>
.register-wrapper {
  background: url('https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1350&q=80') no-repeat center center;
  background-size: cover;
}

.card {
  backdrop-filter: blur(10px);
}
</style>
